module.exports = __webpack_public_path__ + "static/img/rank_65.588cb08.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_65.png
// module id = hUlp
// module chunks = 0